import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBmwComponent } from './simple-icons-bmw.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBmwComponent ],
    exports:      [ SimpleIconsBmwComponent ],
    bootstrap:    []
})
export class SimpleIconsBmwModule {}
